import React from 'react';
import { IoCheckmarkDone } from "react-icons/io5";

const Contact = () => {
  return (
    <div className="p-4">
      <div className="flex flex-col lg:flex-row gap-8 bg-blue-600 p-8 rounded-lg shadow-lg">
        {/* Image Section */}
        <div className="flex-shrink-0 w-full lg:w-1/2">
          <img
            src="https://cdn.wegic.ai/assets/onepage/ai/image/3399e1c2-8e27-41d6-a3a7-9893e6ce3b78.jpeg"
            alt="Get in touch"
            className="rounded-lg w-full object-cover shadow-md"
          />
        </div>

        {/* Text Content */}
        <div className="flex flex-col gap-6 justify-center w-full lg:w-1/2">
          <h1 className="text-3xl md:text-5xl text-white font-extrabold drop-shadow-md text-center lg:text-left">
            Get in touch
          </h1>
          <p className="text-lg md:text-xl text-white leading-relaxed text-center lg:text-left">
            Have questions or need more information? Contact us to learn more about our products and services.
          </p>

          {/* Support Section */}
          <div className="flex flex-col md:flex-row gap-6">
            {/* Column 1 */}
            <div className="text-white text-lg md:text-xl flex flex-col gap-4 items-start">
              <div className="flex gap-4 items-center">
                <IoCheckmarkDone />
                <p className="hover:underline hover:text-gray-300 transition duration-300">
                  Expert customer support
                </p>
              </div>
              <div className="flex gap-4 items-center">
                <IoCheckmarkDone />
                <p className="hover:underline hover:text-gray-300 transition duration-300">
                  Comprehensive product information
                </p>
              </div>
            </div>

            {/* Column 2 */}
            <div className="text-white text-lg md:text-xl flex flex-col gap-4 items-start">
              <div className="flex gap-4 items-center">
                <IoCheckmarkDone />
                <p className="hover:underline hover:text-gray-300 transition duration-300">
                  Fast response time
                </p>
              </div>
              <div className="flex gap-4 items-center">
                <IoCheckmarkDone />
                <p className="hover:underline hover:text-gray-300 transition duration-300">
                  Wholesale and retail options
                </p>
              </div>
            </div>
          </div>

          {/* WhatsApp Info */}
          <div className="font-bold text-lg md:text-xl mt-6 text-center lg:text-left">
            <p className="text-white">
              Whatsapp this number for your order: <span>08142397718</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
